import { PeriodContext } from '../../context/PeriodProvider';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { List } from '../ui/List';
import { Message } from '../ui/Message';
import { Skeleton } from '../ui/Skeleton';
import { InconsistencyCheckClient } from '../../services/InconsistencyCheckClient';
import { UserContext } from '../../context/UserProvider';
import { useParams } from 'react-router-dom';
import { buildQueryKey } from '../../lib/utils';

export const InconsistencyCheck = () => {
    const { period } = useContext(PeriodContext);
    const user = useContext(UserContext);
    const { id } = useParams();
    const { data, isPending, isError } = useQuery({
        queryKey: [buildQueryKey('inconsistencycheck', id), period],
        queryFn: () => InconsistencyCheckClient({ ...user, param: id }).getInconsistencyCheck(period),
    });

    if (isError)
        return <Message type="error">Er is iets misgegaan bij het ophalen van uw inconsistentiecheck. Probeer het later nog een keer.</Message>;

    if (isPending) {
        return (
            <div className="flex flex-col gap-2">
                {[...Array(6)].map((_, index) => (
                    <Skeleton className="w-full h-[30px] rounded-sm" key={index} />
                ))}
            </div>
        );
    }

    if (!data || data.length === 0) return <Message type="info">Geen data gevonden.</Message>;

    return (
        <List>
            {data.map((item) => {
                return <List.CheckItem key={item.key + item.value} label={item.key} value={item.value} />;
            })}
        </List>
    );
};
